module.exports = __webpack_public_path__ + "img/wen.be83dfbf.jpg";